<template>
  <div class="content">
    
    <div style="position: fixed;right:10px;top:300px;z-index:1000">
      <Rightnav @showsp="getshow" @runtops="runtop"></Rightnav>
    </div>
    <transition name="slide-fade">
      <div class="Mask" v-if="showquote">
        <div class="mask-main">
          <i @click="mask" class="iconfont icon-guanbi"></i>
          <Freequote></Freequote>
        </div>
      </div>
    </transition>
    <div class="banane">
      <img src="../assets/images/WechatIMG320.jpeg" />
    </div>
    <div class="main">
      <Tpicker @citydata="getcitydata" :cidatas="posdata"></Tpicker>
      <div class="product-main">
        <ul>
          <li v-for="(item,index) in sjlist.list" :key="index" @click="todetails(item.designid)">
            <div class="ulimg bran-father">
              <img :src="item.img" oncontextmenu="return false;"
              @mouseenter="enter(item)"
              @mouseleave="leave(item)"
              />
              <transition name="slide-fade">
                <div v-if="item.show" class="picture-Mask">
                  <div class="circular">
                    <i class="iconfont icon-quanjingtu" style="color:#fff;font-size:40px;"></i>
                  </div>
                </div>
              </transition>
              <div class="brand" >桔家云</div>
            </div>
            <div class="liname">
              {{item.cnname}}
              <br />
              <span style="font-size: 14px;">{{item.alladname}}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="page">
      <el-pagination
        :page-size="15"
        @current-change="handlecurrentchange"
        :current-page.sync="page"
        background
        layout="prev, pager, next"
        :total="sjlist.totalCount"
      ></el-pagination>
    </div>
    <div>
      <BottomFoot></BottomFoot>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import WOW from "wowjs";

import BottomFoot from "../components/BottomFoot.vue";
import Freequote from "../components/Freequote.vue";
import Rightnav from "../components/Rightnav.vue";
import Tpicker from "../components/Tpicker.vue";
export default {
  components: {
 
    BottomFoot,
    Freequote,
    Rightnav,
    Tpicker
  },
  metaInfo() {
    return {
      meta: [
        {
          name: "description",
          content:
            "家装设计师、室内设计师、装修设计师、大咖云集、整装桔家云整装，汇聚百位大咖装修设计师，为您提供各种风格，各种面积，各种户型的设计方案，一对一专业服务。"
        }
      ]
    };
  },
  data() {
    return {
      nub: "7",
      showquote: false,
      value5: 5,
      page: 1,
      posdata: "",
      show: false,
      sjlist: []
    };
  },
  methods: {
    enter(item) {
      item.show = true;
    },
    leave(item) {
      item.show = false;
    },
    getshow(data) {
      //console.log("data", data);
      this.showquote = data;
    },
    getpositions(data) {
      //console.log("datass", data);
      this.posdata = data;
      this.postsde();
    },
    getcitydata(data) {
      //console.log("getcitydata", data);
      this.posdata.province = data[0];
      this.posdata.city = data[1];
      this.posdata.area = data[2];
      this.postsde();
    },
    mask() {
      this.showquote = false;
    },
    runtop(data) {
      document.documentElement.scrollTop = data;
    },
    handlecurrentchange(size) {
      this.page = size;
      this.postsde();
    },
    postsde: async function() {
      let data = {
        province: this.posdata.province,
        city: this.posdata.city,
        area: this.posdata.area,
        // area:'集美区',
        page: this.page,
        limit: 16
      };
      let res = await this.exequy.cltpanolist(data);
      this.sjlist = res.data.data;
      this.sjlist.list.map((vl, vn) => {
          this.$set(vl, "show", false);
        });
        console.log("this.sjlist",this.sjlist)
    },
    toqjt(data) {
      window.location.href = data;
    },
    todetails: async function(item) {
      this.$router.push({ path: "/PanoramaList", query: { id: item } });
    }
  },
  mounted() {
    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0);
    }),
      new WOW.WOW().init();
  },
  created: async function() {
    let self = this;
    self.postsde()
  }
};
</script>
<style scoped>
img {
  width: 100%;
}
.content {
  width: 100%;
}
.head {
  width: 99.15%;
  overflow: hidden;
  position: fixed;
  top: 0;
  z-index: 1000;
}
.main {
  width: 1340px;
  margin: 0 auto;
  overflow: hidden;
}
.banane {
  width: 100%;
  height: 340px;
  
}
.banane img {
  width: 100%;
  height: 100%;
}
.product-main {
  width: 100%;
}
.bran-father{
  position: relative;
}
.brand{
 width:60px; 
 height:28px; 
 background:#b31d25;
 position:absolute;
 top: 0px;
 right: 0px;
 color: #fff;
 line-height: 28px;
 font-size: 15px;
}
.product-main ul {
  overflow: hidden;
  padding-inline-start: 0px;
  margin-left: -1%;
}
.product-main ul li {
  list-style: none;
  width: 24%;
  float: left;
  margin-left: 1%;
  margin-top: 1.5rem;
  border: 1px solid #ddd;
  box-sizing: border-box;
  padding: 15px;
  border-radius: 7px;
  cursor: pointer;
}
/* .product-main ul li:first-child {
  margin-left: 0%;
} */
.liname {
  font-size: 20px;
  text-align: left;
  color: #000;
}
.liname span {
  color: #c42d28;
}
.product-main ul li img {
  width: 100%;
  height: 100%;
}
.Mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1000;
}
.mask-main {
  border-radius: 15px;
  text-align: center;
  width: 50%;
  height: 60%;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  background-color: white;
  z-index: 10000;
}
.icon-guanbi {
  font-size: 25px;
  position: absolute;
  right: 11px;
  top: 5px;
  line-height: normal;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all .4s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-active
/* .slide-fade-leave-active for below version 2.1.8 */
 {
  /* transform: translateX(10px); */
  opacity: 0;
}
/* .ulimg{
  height: 200px;
} */
.page {
  margin-bottom: 15px; 
}
.picture-Mask {
  width: 100%;
  height: 100%;
  background: #28292c;
  opacity: 0.7;
  position: absolute;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: Center;
}
/* .circular {
  width: 50px;
  height: 50px;
  border: 1px solid #fff;
  border-radius: 25px;
  margin: 0 auto;
} */
</style>
